import React from "react";
import { Star, Quote } from "lucide-react";

const reviews = [
  {
    name: "Beatriz",
    initial: "B",
    color: "bg-violet-100 text-violet-700",
    rating: 5,
    text: "Las chicas son un encanto y los cuidados que dan a mis gatos son geniales. Trato muy cercano, muy claro y sobre todo se nota que les gusta lo que hacen. Dan paz y confianza.",
    testid: "review-beatriz",
  },
  {
    name: "Angel",
    initial: "A",
    color: "bg-cyan-100 text-cyan-700",
    rating: 5,
    text: "Muy buena clínica!! El trato es personalizado y cercano, explicando perfectamente todo lo que le pasa a mi perra. Repetiré seguro.",
    testid: "review-angel",
  },
  {
    name: "Héctor",
    initial: "H",
    color: "bg-amber-100 text-amber-700",
    rating: 5,
    text: "La mejor sin duda, lo recomiendo 100x100. Mis perros están encantados.",
    testid: "review-hector",
  },
];

export const Reviews = () => {
  return (
    <section
      id="resenas"
      data-testid="reviews-section"
      className="py-20 md:py-28 bg-gradient-to-b from-white to-cyan-50/40"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="inline-block text-sm font-semibold text-violet-600 uppercase tracking-wider mb-4">
            Reseñas reales en Google
          </span>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-800 leading-tight">
            Lo que dicen las familias que confían en nosotros.
          </h2>
          <div className="mt-6 flex items-center gap-3">
            <div className="flex items-center">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="w-5 h-5 fill-amber-400 text-amber-400"
                />
              ))}
            </div>
            <p className="text-slate-600">
              <span className="font-semibold text-slate-800">4,9 / 5</span> ·
              basado en 270 reseñas
            </p>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {reviews.map((r) => (
            <article
              key={r.testid}
              data-testid={r.testid}
              className="relative bg-white rounded-3xl p-8 border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_50px_rgb(0,0,0,0.08)] hover:-translate-y-1 transition-all duration-300 flex flex-col"
            >
              <Quote
                className="absolute top-6 right-6 w-10 h-10 text-violet-100"
                strokeWidth={1.5}
              />
              <div className="flex items-center gap-1 mb-4">
                {[...Array(r.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-5 h-5 fill-amber-400 text-amber-400"
                  />
                ))}
              </div>
              <p className="text-slate-700 leading-relaxed flex-1">
                “{r.text}”
              </p>
              <div className="mt-6 pt-6 border-t border-slate-100 flex items-center gap-3">
                <div
                  className={`w-11 h-11 rounded-full flex items-center justify-center font-semibold font-['Outfit'] ${r.color}`}
                >
                  {r.initial}
                </div>
                <div>
                  <p className="font-semibold text-slate-800 font-['Outfit']">
                    {r.name}
                  </p>
                  <p className="text-xs text-slate-500">Reseña verificada</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
